<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="exportAllProductionReportByCategory()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-autocomplete
                label="Choose Finance Setting..."
                v-model="queryParams.financeSettingId"
                :items="financeSettingList"
                color="blue-grey lighten-2"
                item-text="financialYearName"
                item-value="id"
                menu-props="auto"
                :hide-no-data="true"
                @change="bindMonth(queryParams.financeSettingId)"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-menu
                ref="menu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="queryParams.orderMonth"
                    label="Order Month"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="queryParams.orderMonth"
                  type="month"
                  :min="minMonth"
                  :max="maxMonth"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="categoryName"
                label="Category Name"
                type="text"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="productionReportByCategoryList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.categoryName }}</td>
              <td>{{ props.item.factorUnitName }}</td>
              <td style="text-align: right;">{{ props.item.price | decFormat(6) }}</td>
              <td style="text-align: right;">
                {{ props.item.financeSettingPlanQty | decFormat(6) }}
              </td>
              <td style="text-align: right;">
                {{ props.item.financeSettingPlanAmount | decFormat(6) }}
              </td>
              <td style="text-align: right;">{{ props.item.orderMonthPlanQty | decFormat(6) }}</td>
              <td style="text-align: right;">
                {{ props.item.orderMonthPlanAmount | decFormat(6) }}
              </td>
              <td style="text-align: right;">
                {{ props.item.orderMonthProductionQty | decFormat(6) }}
              </td>
              <td style="text-align: right;">
                {{ props.item.orderMonthProductionAmount | decFormat(6) }}
              </td>
              <td style="text-align: right;">
                {{ props.item.orderMonthSuccessPercentage | decFormat(2) }}
              </td>
              <td style="text-align: right;">
                {{ props.item.startToOrderMonthPlanQty | decFormat(6) }}
              </td>
              <td style="text-align: right;">
                {{ props.item.startToOrderMonthPlanAmount | decFormat(6) }}
              </td>
              <td style="text-align: right;">
                {{ props.item.startToOrderMonthProductionQty | decFormat(6) }}
              </td>
              <td style="text-align: right;">
                {{
                  props.item.startToOrderMonthProductionAmount | decFormat(6)
                }}
              </td>
              <td style="text-align: right;">
                {{
                  props.item.startToOrderMonthSuccessPercentage | decFormat(2)
                }}
              </td>
              <td style="text-align: right;">
                {{ props.item.financeSettingSuccessPercentage | decFormat(2) }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { productionReportByCategoryService } from "../../services/production-report-by-category-service";
import { commonService } from "../../services/common-service";
import { financeSettingService } from "../../services/finance-setting-service";

export default {
  name: "ProductionReportByCategory",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    buttonLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Manufacturing Management",
        disabled: true,
      },
      {
        text: "Production Report By Category",
        disabled: true,
      },
    ],
    queryParams: {
      financeSettingId: "",
      orderMonth: "",
      categoryName: "",
    },
    headers: [
      { text: "Category", align: "left", sortable: false },
      { text: "Unit", align: "left", sortable: false },
      { text: "Price", align: "right", sortable: false },
      { text: "Plan Qty()", align: "right", sortable: false },
      { text: "Plan Amount()", align: "right", sortable: false },
      { text: "Plan Qty()", align: "right", sortable: false },
      { text: "Plan Amount()", align: "right", sortable: false },
      { text: "Production Qty()", align: "right", sortable: false },
      { text: "Production Amount()", align: "right", sortable: false },
      { text: "Success Percentage()", align: "left", sortable: false },
      { text: "Plan Qty()", align: "right", sortable: false },
      { text: "Plan Amount()", align: "right", sortable: false },
      { text: "Production Qty()", align: "right", sortable: false },
      { text: "Production Amount()", align: "right", sortable: false },
      { text: "Success Percentage()", align: "right", sortable: false },
      { text: "Success Percentage()", align: "right", sortable: false },
    ],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "c.name",
      totalItems: 0,
    },
    rowsPerPageItems: [25, 50, 100],
    totalRows: 0,
    clonequeryParams: new Object(),
    productionReportByCategoryList: [],
    financeSettingList: [],
    maxMonth: "",
    minMonth: "",
  }),
  watch: {
    pagination: {
      handler() {
        this.getProductionReportByCategory();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    if (this.$route.query.financeSettingId) {
      this.queryParams.financeSettingId = this.$route.query.financeSettingId;
    }
    if (this.$route.query.orderMonth) {
      this.queryParams.orderMonth = this.$route.query.orderMonth;
    }
    if (this.$route.query.categoryName) {
      this.queryParams.categoryName = this.$route.query.categoryName;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }

    this.getFinanceSettingList();
  },
  methods: {
    getFinanceSettingList() {
      financeSettingService
        .getAllFinanceSetting()
        .then((res) => {
          if (res.data) {
            this.financeSettingList = res.data.financeSettingDTOs;
            this.queryParams.financeSettingId = 1;
            this.bindMonth(this.queryParams.financeSettingId);
            this.onSearch();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    bindMonth(id) {
      let financeSetting = commonService.search(
        "id",
        id,
        this.financeSettingList
      );
      this.minMonth = financeSetting.startMonth;
      this.maxMonth = financeSetting.endMonth;
      this.queryParams.orderMonth = financeSetting.startMonth;
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "production-report-by-category",
        query: this.queryParams,
      });
      this.getProductionReportByCategory();
      this.dynamicHeader();
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
    },
    dynamicHeader() {
      let financeSetting = commonService.search(
        "id",
        this.queryParams.financeSettingId,
        this.financeSettingList
      );
      this.headers.splice(3, 1, {
        text: `Plan Qty(${financeSetting.financialYearName})`,
        align: "right",
        sortable: false,
      });
      this.headers.splice(4, 1, {
        text: `Plan Amount(${financeSetting.financialYearName})`,
        align: "right",
        sortable: false,
      });
      this.headers.splice(5, 1, {
        text: `Plan Qty(${this.queryParams.orderMonth})`,
        align: "right",
        sortable: false,
      });
      this.headers.splice(6, 1, {
        text: `Plan Amount(${this.queryParams.orderMonth})`,
        align: "right",
        sortable: false,
      });
      this.headers.splice(7, 1, {
        text: `Production Qty(${this.queryParams.orderMonth})`,
        align: "right",
        sortable: false,
      });
      this.headers.splice(8, 1, {
        text: `Production Amount(${this.queryParams.orderMonth})`,
        align: "right",
        sortable: false,
      });
      this.headers.splice(9, 1, {
        text: `Success Percentage(${this.queryParams.orderMonth})`,
        align: "right",
        sortable: false,
      });
      this.headers.splice(10, 1, {
        text: `Plan Qty(${financeSetting.startMonth} to ${this.queryParams.orderMonth})`,
        align: "right",
        sortable: false,
      });
      this.headers.splice(11, 1, {
        text: `Plan Amount(${financeSetting.startMonth} to ${this.queryParams.orderMonth})`,
        align: "right",
        sortable: false,
      });
      this.headers.splice(12, 1, {
        text: `Production Qty(${financeSetting.startMonth} to ${this.queryParams.orderMonth})`,
        align: "right",
        sortable: false,
      });
      this.headers.splice(13, 1, {
        text: `Production Amount(${financeSetting.startMonth} to ${this.queryParams.orderMonth})`,
        align: "right",
        sortable: false,
      });
      this.headers.splice(14, 1, {
        text: `Success Percentage(${financeSetting.startMonth} to ${this.queryParams.orderMonth})`,
        align: "right",
        sortable: false,
      });
      this.headers.splice(15, 1, {
        text: `Success Percentage(${financeSetting.financialYearName})`,
        align: "right",
        sortable: false,
      });
    },
    getProductionReportByCategory() {
      if (this.queryParams.financeSettingId && this.queryParams.orderMonth) {
        this.showListLoading = true;
        let order = this.pagination.descending ? "desc" : "asc";
        productionReportByCategoryService
          .getProductionReportByCategoryList(
            this.queryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.productionReportByCategoryList = res.data.productionReportByCategoryList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      }
    },
    exportAllProductionReportByCategory() {
      this.buttonLoading = true;
      productionReportByCategoryService
        .exportAllProductionReportByCategoryList(this.clonequeryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
  },
};
</script>
  